// extracted by mini-css-extract-plugin
export var box = "box-module--box--2ljMn";
export var transitionBg = "box-module--transitionBg--EZ4bn";
export var title = "box-module--title--27cPN";
export var desc = "box-module--desc--3_0xA";